import { memo, useMemo } from 'react'

import { getFeatureIcon } from '@wwt/shared/utils/getFeatureIcon'

export interface FeatureIconProps {
	groupIconName?: string
	featureIconName?: string
	optionIconName?: string
	className?: string
}

export const FeatureIcon = memo(
	({
		groupIconName,
		featureIconName,
		optionIconName,
		className
	}: FeatureIconProps) => {
		const IconForRender = useMemo(
			() => getFeatureIcon(groupIconName, featureIconName, optionIconName),
			[groupIconName, featureIconName, optionIconName]
		)

		if (!IconForRender) {
			return null
		}

		return <IconForRender className={className} />
	}
)

FeatureIcon.displayName = 'FeatureIcon'
